<template>
  <div class="signature-pad-field">
    <canvas
      ref="pad"
      class="signature-pad"
      width="420"
      height="140"
      aria-label="Signature"
      @pointerdown="startDraw"
      @pointermove="draw"
      @pointerup="finishStroke"
      @pointercancel="finishStroke"
    ></canvas>
    <p v-if="!autosave" class="signature-note">Draw, then save the signature. An empty pad is not stored.</p>
    <p v-if="note" class="signature-note signature-note-warn">{{ note }}</p>
    <div class="signature-actions">
      <button type="button" class="btn btn-sm btn-outline-secondary" @click="clearPad">Clear</button>
      <button v-if="!autosave" type="button" class="btn btn-sm btn-primary" @click="saveDrawing">Save signature</button>
    </div>
  </div>
</template>

<script>
import { imageUploadFromDataUrl } from '../../../shared/image-column'

export default {
  name: 'SignaturePad',
  props: {
    autosave: { type: Boolean, default: false }
  },
  data () {
    return { drawing: false, inked: false, note: '' }
  },
  mounted () {
    this.prepareCanvas()
  },
  methods: {
    prepareCanvas () {
      const canvas = this.$refs.pad
      if (!canvas) return
      const context = canvas.getContext('2d')
      context.fillStyle = '#fff'
      context.fillRect(0, 0, canvas.width, canvas.height)
      context.strokeStyle = '#172018'
      context.lineWidth = 2
      context.lineCap = 'round'
    },
    point (event) {
      const canvas = this.$refs.pad
      const rect = canvas.getBoundingClientRect()
      return {
        x: (event.clientX - rect.left) * (canvas.width / rect.width),
        y: (event.clientY - rect.top) * (canvas.height / rect.height)
      }
    },
    startDraw (event) {
      this.$refs.pad.setPointerCapture(event.pointerId)
      this.drawing = true
      const point = this.point(event)
      const context = this.$refs.pad.getContext('2d')
      context.beginPath()
      context.moveTo(point.x, point.y)
    },
    draw (event) {
      if (!this.drawing) return
      this.inked = true
      this.note = ''
      const point = this.point(event)
      const context = this.$refs.pad.getContext('2d')
      context.lineTo(point.x, point.y)
      context.stroke()
    },
    finishStroke () {
      const shouldStore = this.drawing && this.inked && this.autosave
      this.drawing = false
      if (shouldStore) this.saveDrawing()
    },
    clearPad () {
      this.inked = false
      this.note = ''
      this.prepareCanvas()
      this.$emit('input', null)
    },
    saveDrawing () {
      if (!this.inked) {
        this.note = 'Draw a signature first. An empty pad is not stored.'
        return
      }
      const upload = imageUploadFromDataUrl(this.$refs.pad.toDataURL('image/png'), 'signature.png', 'image/png')
      this.$emit('input', upload)
      if (!this.autosave) this.note = ''
    }
  }
}
</script>

<style scoped>
.signature-pad {
  display: block;
  width: 100%;
  max-width: 420px;
  height: 140px;
  background: #fff;
  border: 1px solid #c8cdc4;
  border-radius: 4px;
  touch-action: none;
  cursor: crosshair;
}
.signature-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}
.signature-note {
  margin: 8px 0 0;
  color: inherit;
  opacity: 0.8;
  font-size: 0.8rem;
}
.signature-note-warn {
  color: #b91c1c;
  opacity: 1;
}
</style>
